import axios, { AxiosError} from "axios"; //引入
import { Toast } from "antd-mobile";
import {axiosConfig} from "@/config/axios";


const { base_url,request_timeout } = axiosConfig as any

const env = process.env.REACT_APP_ENV || "development";

const baseURL = base_url[env];

const instance = axios.create({
  baseURL: baseURL,
  timeout: request_timeout //设置最大请求时间
});

instance.interceptors.request.use(
  (config) => {
    return config;
  },
  
  (err) => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  (result) => {
    return result.data;
  },
  (err: AxiosError<{ message: string }>) => {
    // 网络问题
    if (!err.response) {
      Toast.show({
          content: "网络繁忙，请稍后再试",
      });
    }
    const { response } = err
   if (response?.status !== 401) {
       Toast.show({
          content: response?.data.message || '出错了',
       });
      return Promise.reject(err)
    }

    return Promise.reject(err);
 
  }
);
export default instance;
